import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    selectedBookingListStatus: null
}

export const bookingSlice = createSlice({
    name: "booking",
    initialState,
    reducers: {
        setSelectedBookingListStatus: (state, action) => {
            state.selectedBookingListStatus = action.payload
        },
    }
})

export const { setSelectedBookingListStatus } = bookingSlice.actions
export default bookingSlice.reducer